import { Dialog } from 'primereact/dialog';
import { Fieldset } from 'primereact/fieldset';
import { FC } from 'react';

interface Props {
  show: boolean;
  setShow: (s: boolean) => void;
  header: string;
  fieldSets?: { id: string; legend: string; text: string; url?: string }[];
}

export const SkillResourceModal: FC<Props> = ({ show, setShow, header, fieldSets }) => {
  return (
    <Dialog header={header} className="nc_modal-wide" visible={show} onHide={() => setShow(false)}>
      <div className="tw-w-full tw-flex tw-flex-col tw-gap-4">
        {fieldSets?.map(fieldlset => (
          <Fieldset key={fieldlset.id} legend={fieldlset.legend}>
            <p>{fieldlset.text}</p>
          </Fieldset>
        ))}
      </div>
    </Dialog>
  );
};
